/**
 * Motivational Quotes from Famous Athletes and Coaches
 * Rotates daily based on date
 */

export const ATHLETE_QUOTES = [
  {
    quote: "Hard work beats talent when talent doesn't work hard.",
    author: "Tim Notke",
    sport: "Basketball Coach"
  },
  {
    quote: "The only way to prove that you're a good sport is to lose.",
    author: "Ernie Banks",
    sport: "Baseball"
  },
  {
    quote: "You miss 100% of the shots you don't take.",
    author: "Wayne Gretzky",
    sport: "Hockey"
  },
  {
    quote: "It's not whether you get knocked down; it's whether you get up.",
    author: "Vince Lombardi",
    sport: "Football Coach"
  },
  {
    quote: "The more difficult the victory, the greater the happiness in winning.",
    author: "Pelé",
    sport: "Soccer"
  },
  {
    quote: "Champions keep playing until they get it right.",
    author: "Billie Jean King",
    sport: "Tennis"
  },
  {
    quote: "I've failed over and over and over again in my life. And that is why I succeed.",
    author: "Michael Jordan",
    sport: "Basketball"
  },
  {
    quote: "The difference between the impossible and the possible lies in a person's determination.",
    author: "Tommy Lasorda",
    sport: "Baseball"
  },
  {
    quote: "Excellence is not a singular act, but a habit. You are what you repeatedly do.",
    author: "Shaquille O'Neal",
    sport: "Basketball"
  },
  {
    quote: "Persistence can change failure into extraordinary achievement.",
    author: "Marv Levy",
    sport: "Football Coach"
  },
  {
    quote: "The only person who can stop you from reaching your goals is you.",
    author: "Jackie Joyner-Kersee",
    sport: "Track & Field"
  },
  {
    quote: "Set your goals high, and don't stop till you get there.",
    author: "Bo Jackson",
    sport: "Football/Baseball"
  },
  {
    quote: "I hated every minute of training, but I said, 'Don't quit. Suffer now and live the rest of your life as a champion.'",
    author: "Muhammad Ali",
    sport: "Boxing"
  },
  {
    quote: "Today I will do what others won't, so tomorrow I can accomplish what others can't.",
    author: "Jerry Rice",
    sport: "Football"
  },
  {
    quote: "You have to expect things of yourself before you can do them.",
    author: "Michael Jordan",
    sport: "Basketball"
  },
  {
    quote: "Winning isn't everything, but wanting to win is.",
    author: "Vince Lombardi",
    sport: "Football Coach"
  },
  {
    quote: "The principle is competing against yourself. It's about self-improvement, about being better than you were the day before.",
    author: "Steve Young",
    sport: "Football"
  },
  {
    quote: "Age is no barrier. It's a limitation you put on your mind.",
    author: "Jackie Joyner-Kersee",
    sport: "Track & Field"
  },
  {
    quote: "Never let the fear of striking out keep you from playing the game.",
    author: "Babe Ruth",
    sport: "Baseball"
  },
  {
    quote: "The five S's of sports training are: stamina, speed, strength, skill, and spirit; but the greatest of these is spirit.",
    author: "Ken Doherty",
    sport: "Athletics"
  },
  {
    quote: "You're never a loser until you quit trying.",
    author: "Mike Ditka",
    sport: "Football"
  },
  {
    quote: "Make sure your worst enemy doesn't live between your own two ears.",
    author: "Laird Hamilton",
    sport: "Surfing"
  },
  {
    quote: "Do you know what my favorite part of the game is? The opportunity to play.",
    author: "Mike Singletary",
    sport: "Football"
  },
  {
    quote: "The mind is the limit. As long as the mind can envision the fact that you can do something, you can do it.",
    author: "Arnold Schwarzenegger",
    sport: "Bodybuilding"
  },
  {
    quote: "One man practicing sportsmanship is far better than 50 preaching it.",
    author: "Knute Rockne",
    sport: "Football Coach"
  },
  {
    quote: "What makes something special is not just what you have to gain, but what you feel there is to lose.",
    author: "Andre Agassi",
    sport: "Tennis"
  },
  {
    quote: "Push yourself again and again. Don't give an inch until the final buzzer sounds.",
    author: "Larry Bird",
    sport: "Basketball"
  },
  {
    quote: "The harder the battle, the sweeter the victory.",
    author: "Les Brown",
    sport: "Motivational Speaker"
  },
  {
    quote: "If you can believe it, the mind can achieve it.",
    author: "Ronnie Lott",
    sport: "Football"
  },
  {
    quote: "Somewhere behind the athlete you've become and the hours of practice and the coaches who have pushed you is a little girl who fell in love with the game.",
    author: "Mia Hamm",
    sport: "Soccer"
  },
  {
    quote: "Without self-discipline, success is impossible, period.",
    author: "Lou Holtz",
    sport: "Football Coach"
  }
];

/**
 * Get today's quote based on day of year
 */
export const getDailyQuote = () => {
  const now = new Date();
  const start = new Date(now.getFullYear(), 0, 0);
  const diff = now - start;
  const oneDay = 1000 * 60 * 60 * 24;
  const dayOfYear = Math.floor(diff / oneDay);
  
  return ATHLETE_QUOTES[dayOfYear % ATHLETE_QUOTES.length];
};

/**
 * Get a random quote
 */
export const getRandomQuote = () => {
  return ATHLETE_QUOTES[Math.floor(Math.random() * ATHLETE_QUOTES.length)];
};

/**
 * Daily Challenges - Quick tasks to build consistency
 */
export const DAILY_CHALLENGES = [
  {
    id: 'hydration',
    title: 'Hydration Hero',
    description: 'Drink 8 glasses of water today',
    icon: 'droplet',
    category: 'nutrition',
    points: 10
  },
  {
    id: 'stretch',
    title: 'Morning Stretch',
    description: 'Complete a 10-minute stretch routine',
    icon: 'activity',
    category: 'recovery',
    points: 15
  },
  {
    id: 'protein',
    title: 'Protein Power',
    description: 'Hit your daily protein goal',
    icon: 'beef',
    category: 'nutrition',
    points: 15
  },
  {
    id: 'sleep',
    title: 'Sleep Champion',
    description: 'Get 8+ hours of sleep tonight',
    icon: 'moon',
    category: 'recovery',
    points: 20
  },
  {
    id: 'workout',
    title: 'Daily Grind',
    description: 'Complete any workout today',
    icon: 'dumbbell',
    category: 'training',
    points: 25
  },
  {
    id: 'cardio',
    title: 'Cardio Crusher',
    description: 'Do 20 minutes of cardio',
    icon: 'heart',
    category: 'training',
    points: 20
  },
  {
    id: 'visualize',
    title: 'Mental Rep',
    description: 'Spend 5 minutes visualizing success',
    icon: 'brain',
    category: 'mental',
    points: 10
  },
  {
    id: 'nosugar',
    title: 'Sugar Free',
    description: 'Avoid added sugars today',
    icon: 'ban',
    category: 'nutrition',
    points: 15
  },
  {
    id: 'veggies',
    title: 'Veggie Victory',
    description: 'Eat 5 servings of vegetables',
    icon: 'carrot',
    category: 'nutrition',
    points: 15
  },
  {
    id: 'journal',
    title: 'Reflect & Write',
    description: 'Journal about your goals for 5 minutes',
    icon: 'pencil',
    category: 'mental',
    points: 10
  },
  {
    id: 'core',
    title: 'Core Crusher',
    description: 'Do 50 reps of any core exercise',
    icon: 'target',
    category: 'training',
    points: 15
  },
  {
    id: 'recovery',
    title: 'Active Recovery',
    description: 'Do foam rolling or massage for 10 mins',
    icon: 'sparkles',
    category: 'recovery',
    points: 15
  },
  {
    id: 'nophone',
    title: 'Focus Mode',
    description: 'No phone 1 hour before bed',
    icon: 'smartphone-off',
    category: 'recovery',
    points: 10
  },
  {
    id: 'breakfast',
    title: 'Breakfast Boss',
    description: 'Eat a balanced breakfast with protein',
    icon: 'egg',
    category: 'nutrition',
    points: 10
  }
];

/**
 * Get today's challenges (3 random ones based on day)
 */
export const getDailyChallenges = () => {
  const now = new Date();
  const dayOfYear = Math.floor((now - new Date(now.getFullYear(), 0, 0)) / (1000 * 60 * 60 * 24));
  
  // Use day of year as seed for consistent daily challenges
  const shuffled = [...DAILY_CHALLENGES].sort((a, b) => {
    const hashA = (dayOfYear * 31 + a.id.charCodeAt(0)) % 100;
    const hashB = (dayOfYear * 31 + b.id.charCodeAt(0)) % 100;
    return hashA - hashB;
  });
  
  return shuffled.slice(0, 3);
};
